var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Popover from '@mui/material/Popover';
import { useDeviceView } from '@/hooks/use-device-view';
export function PopoverFilter(props) {
    var isMobileView = useDeviceView().isMobileView;
    return (_jsx(Popover, __assign({}, props, { anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
        }, slotProps: {
            paper: {
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: isMobileView ? undefined : 600,
                    minHeight: isMobileView ? undefined : 200,
                    overflow: 'auto',
                    width: 500,
                    padding: 2,
                },
            },
        } })));
}
